import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { MatButtonModule} from '@angular/material/button';

import { AvatarModule } from '../../components/avatar/avatar.module';
import { ListingModule } from '../../components/listing/listing.module';
import { DirectivesModule } from '../../directives/directive.module';
import { HelpTooltipModule } from '../../components/helpTooltip/helpTooltip.module';
import { MatDialogModule } from '@angular/material/dialog';
import { EditReminderDialogModule } from '../../components/edit-reminder-dialog/edit-reminder-dialog.module';
import { RemindersComponent } from './reminders.component';
import { MatIconModule } from '@angular/material/icon';
import { DocumentsDialogModule  } from '../../components/documents/documents-dialog.module';

@NgModule({
    imports: [
        CommonModule,
        DocumentsDialogModule,
        FormsModule,
        MatButtonModule,
        MatIconModule,
        EditReminderDialogModule,
        InfiniteScrollModule,
        AvatarModule,
        MatDialogModule,
        ListingModule,
        DirectivesModule,
        HelpTooltipModule
    ],
    declarations: [
        RemindersComponent
    ],
    exports: [
        RemindersComponent
    ]
})
export class RemindersModule { }
